module.exports = __webpack_public_path__ + "static/media/phone.c6e25ba8.svg";